<template>
    <TableLayout :permissions="['business:empower:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="姓名手机号" prop="memberName">
                <el-input v-model="searchForm.memberName" placeholder="请输入姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="下发状态" prop="sendStatus">
                <el-select v-model="searchForm.sendStatus" placeholder="请选择" @keypress.enter.native="search">
                    <el-option label="待下发" value="0"></el-option>
                    <el-option label="任务执行" value="1"></el-option>
                    <el-option label="下发成功" value="2"></el-option>
                    <el-option label="已取消" value="3"></el-option>
                    <el-option label="下发失败" value="4"></el-option>
                    <el-option label="任务下载已结束" value="5"></el-option>
                    <el-option label="不符合下发条件" value="6"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="公司" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="下发起始时间" prop="startTime">
                <el-date-picker
                    @change="seleTime"
                    v-model="time"
                    @keypress.enter.native="search"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-radio-group v-model="searchForm.radio" size="small" @input="changeRadio">
                <el-radio-button label="0">当天</el-radio-button>
                <el-radio-button label="1">近7天</el-radio-button>
                <el-radio-button label="2">近30天</el-radio-button>
            </el-radio-group>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:empower:create', 'business:empower:delete']">
                <li><el-button type="primary" v-permissions="['business:empower:create']">导出</el-button></li>
<!--                <li><el-button type="primary" v-permissions="['business:empower:create']">立即下发</el-button></li>-->
<!--                <li><el-button type="primary" v-permissions="['business:empower:create']">取消下发</el-button></li>-->
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="memberName" label="姓名" min-width="80px"></el-table-column>
                <el-table-column prop="memberPhone" label="手机号" min-width="120px"></el-table-column>
                <el-table-column prop="memberidCard" label="身份证号码" min-width="130px"></el-table-column>
                <el-table-column prop="companyName" label="所属公司" min-width="150px"></el-table-column>
                <el-table-column prop="deviceName" label="设备名称" min-width="150px"></el-table-column>
                <el-table-column label="门禁有效期" min-width="170px">
                    <template slot-scope="{row}">
                        <span v-if="!row.startTime || !row.endTime">长期</span>
                        <div v-else>
                            <span>起：{{row.startTime}}</span><br />
                            <span>止：{{row.endTime}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sendDate" label="创建时间" min-width="150px"></el-table-column>
                <el-table-column label="是否删除" min-width="100px">
                    <template slot-scope="{row}">
                        <span style="color: green;" v-if="row.isdeleted === 0">否</span>
                        <span style="color: red;" v-if="row.isdeleted === 1">是</span>
                    </template>
                </el-table-column>
<!--                <el-table-column prop="createrName" label="操作人员" min-width="100px"></el-table-column>-->
                <el-table-column label="下发状态" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.sendStatus === 0">待下发</span>
                        <span v-if="row.sendStatus === 1">任务执行</span>
                        <span v-if="row.sendStatus === 2">下发成功</span>
                        <span v-if="row.sendStatus === 3">已取消</span>
                        <span v-if="row.sendStatus === 4">下发失败</span>
                        <span v-if="row.sendStatus === 5">任务下载已结束</span>
                        <span v-if="row.sendStatus === 6">不符合下发条件</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendType" label="下发类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.sendType === 0">实时</span>
                        <span v-if="row.sendType === 1">定时</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sendDate" label="下发时间" min-width="150px"></el-table-column>
                <el-table-column prop="sendInfo" label="下发备注" min-width="150px"></el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { timeForMat } from '@/utils/util'
export default {
  name: 'Empower',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        memberName: '',
        companyName: '',
        sendStartDate: '',
        sendEndDate: '',
        startTime: '',
        endTime: '',
        sendStatus: '',
        radio: null
      },
      time: []
    }
  },
  created () {
    this.config({
      module: '人员授权导入记录',
      api: '/business/empower',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.changeRadio('0')
    this.search()
  },
  methods: {
    changeRadio (e) {
      this.searchForm.radio = e
      if (e === '0') {
        this.searchForm.sendStartDate = timeForMat(0)[0]
        this.searchForm.sendEndDate = timeForMat(0)[1]
        this.time = timeForMat(0)
      } else if (e === '1') {
        this.searchForm.sendStartDate = timeForMat(6)[0]
        this.searchForm.sendEndDate = timeForMat(6)[1]
        this.time = timeForMat(6)
      } else if (e === '2') {
        this.searchForm.sendStartDate = timeForMat(29)[0]
        this.searchForm.sendEndDate = timeForMat(29)[1]
        this.time = timeForMat(29)
      }
      this.search()
    },
    seleTime (e) {
      this.searchForm.sendStartDate = e[0]
      this.searchForm.sendEndDate = e[1]
      this.searchForm.radio = null
      this.search()
    },
    reset () {
      this.$refs.searchForm.resetFields()
      this.searchForm.radio = '0'
      this.changeRadio('0')
      // this.search()
    }
  }
}
</script>
